'use client';

import { ChevronLeft, ChevronRight } from 'lucide-react';
import { FC, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import { clsx } from 'clsx';
import { Swiper as SwiperApi } from 'swiper/types';

import { ProductCardType } from '@shared/types/product';
import { SectionTitle } from '@shared/ui/SectionTitle';
import { HStack } from '@shared/ui/Stack';
import { ProductCard } from '@widgets/ProductCard';

import cls from './BlogPostProducts.module.scss';

type BlogPostProductsProps = {
  products: ProductCardType[];
};

export const BlogPostProducts: FC<BlogPostProductsProps> = ({ products }) => {
  const [swiper, setSwiper] = useState<SwiperApi>();
  const [canSlidePrev, setCanSlidePrev] = useState(false);
  const [canSlideNext, setCanSlideNext] = useState(false);

  const updateNavigationState = (api: SwiperApi) => {
    setCanSlidePrev(!api.isBeginning);
    setCanSlideNext(!api.isEnd);
  };

  if (!products.length) {
    return null;
  }

  return (
    <section className={cls.wrap}>
      <HStack className={cls.titleWrapper}>
        <SectionTitle
          className={cls.title}
          tag="h2"
        >
          Подборка товаров по категории
        </SectionTitle>
        {products.length > 1 && (
          <div className={cls.controls}>
            <button
              className={clsx(cls.control, { [cls.disable]: !canSlidePrev })}
              type="button"
              aria-label="Предыдущие товары"
              disabled={!canSlidePrev}
              onClick={() => swiper?.slidePrev()}
            >
              <ChevronLeft />
            </button>
            <button
              className={clsx(cls.control, { [cls.disable]: !canSlideNext })}
              type="button"
              aria-label="Следующие товары"
              disabled={!canSlideNext}
              onClick={() => swiper?.slideNext()}
            >
              <ChevronRight />
            </button>
          </div>
        )}
      </HStack>
      <Swiper
        className={cls.slider}
        speed={1000}
        slidesPerView={1}
        spaceBetween={12}
        breakpoints={{
          520: {
            slidesPerView: 1,
            spaceBetween: 12
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 16
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 16
          }
        }}
        onInit={(api) => {
          setSwiper(api);
          updateNavigationState(api);
        }}
        onResize={updateNavigationState}
        onSlideChange={updateNavigationState}
      >
        {products.map((product) => (
          <SwiperSlide key={product.id}>
            <ProductCard
              data={product}
              view="grid"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};
